import { Button } from '@shared/components/ui/button';
import { Tooltip } from '@shared/components/ui/tooltip';
import { useTranslation } from 'react-i18next';

interface EligibleShipmentsTopBarActionsProps {
  onPrefacturar: () => void;
  prefacturarDisabled?: boolean;
}

export const EligibleShipmentsTopBarActions = ({
  onPrefacturar,
  prefacturarDisabled = false,
}: EligibleShipmentsTopBarActionsProps) => {
  const { t } = useTranslation('invoicesOrdersModule');

  const prefacturarButton = (
    <Button variant="primary" onClick={onPrefacturar} disabled={prefacturarDisabled} data-testid="prefacturar-button">
      {t('buttons.prefacturar', 'Prefacturar')}
    </Button>
  );

  if (prefacturarDisabled) {
    return (
      <Tooltip
        content={
          <div className="bg-card-bg border border-card-border rounded-lg p-3 max-w-xs">
            <p className="text-sm text-text">
              {t(
                'buttons.prefacturar_tooltip',
                'Una vez establecido al menos un filtro, se pueden prefacturar los resultados a los que se aplica la regla.',
              )}
            </p>
          </div>
        }
        trigger={<span>{prefacturarButton}</span>}
        side="bottom"
        align="center"
        className="bg-transparent border-0 shadow-none"
      />
    );
  }

  return prefacturarButton;
};
